module.exports = __webpack_public_path__ + "static/media/logo.453a1a9c.jpeg";